export enum TabIcons {
    NewAction = "star",
    PatientDetails = "circle-user",
    Topics = "file-magnifying-glass",
    EncounterLookup = "print-magnifying-glass",
    Settings = "gear",
    BedsideShiftReport = "folder-medical",
}

export enum IconsFamily {
    Regular = "far",
    Solid = "fas",
    Light = "fal",
    Thin = "fat",
}
